import { render } from "./vendorCode13.vue?vue&type=template&id=23dbd5fc"
import script from "./vendorCode13.vue?vue&type=script&lang=js"
export * from "./vendorCode13.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__